<template>
  <footer class="main-footer">
    <h4 class="text-center subscribe">
      Подписывайтесь на самые актуальные новости в удобном формате!
    </h4>
    <the-social-links />
    <a
      :href="$getConst('DEMIS_COMPANY_TERMS_URL')"
      target="_blank"
    >Пользовательское соглашение</a>
    <div class="pull-right">
      &copy; 2004-{{ new Date() | moment('YYYY') }}. Demis Group
    </div>
  </footer>
</template>

<script>
import TheSocialLinks from './TheSocialLinks.vue'

/**
 * Футер.
 */
export default {
  name: 'CFooter',
  components: {
    TheSocialLinks
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.main-footer {
  .pull-right {
    @media (max-width: $xsBreakpoint) {
      float: none !important;
    }
  }
  .subscribe {
    margin-bottom: 25px;
  }
}
</style>
